import { Button, Col, Input, Popover, Modal, Select, Space, Table } from "antd";
import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import { BudgetApi } from "../../../../api";
import SubItemTable from "./subItemTable";
const ItemTable = (props) => {
  const { projectId, defaultSelectedItems, editId } = props;
  const { Option } = Select;
  const [selectedItems, setSelectedItems] = useState([]);
  const [visible, setVisible] = useState(false);
  const [items, setItems] = useState([]);
  const [selectedRowKeysSub, setSelectedRowKeysSub] = useState([]);
  const [selectedRowsSub, setSelectedRowsSub] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedSubs, setSelectedSubs] = useState({});
  const [selectedSubsKeys, setSelectedSubsKeys] = useState([]);
  const [defaultTax, setDefaultTax] = useState(null);

  const taxTypes = [
    {
      id: 1,
      label: "None",
      value: "none",
    },
    {
      id: 2,
      label: "CGST/SGST",
      value: "cgst_sgst",
    },
    {
      id: 4,
      label: "IGST",
      value: "igst",
    },
  ];
  useEffect(() => {
    console.log(props, "props");
    fetchItems();
    // if (props.editId) {
    //   console.log(props.defaultSelectedItems, "ss");
    //   setSelectedItems(props.defaultSelectedItems);
    // }
  }, []);
  // useEffect(() => {
  //   // setSelectedItems(defaultSelectedItems);
  //   var item = [];
  //   var itemKeys = [];
  //   var sub_item = [];
  //   var sub_itemKeys = [];
  //   for (let i = 0; i < defaultSelectedItems?.length; i++) {
  //     if (defaultSelectedItems[i]?.sub_items?.length === 0) {
  //       item.push(defaultSelectedItems[i]);
  //       itemKeys.push(defaultSelectedItems[i]?.id);
  //     } else if (defaultSelectedItems[i]?.boq_sub_item) {
  //       sub_item.push(defaultSelectedItems[i]);
  //       sub_itemKeys.push(defaultSelectedItems[i]?.id);
  //     }
  //   }
  //   console.log(sub_item, "sub_item");
  //   setSelectedRowKeys(itemKeys);
  //   setSelectedRows(item);
  //   setSelectedRowsSub(sub_item);
  //   setSelectedRowKeysSub(sub_itemKeys);
  // }, [defaultSelectedItems]);
  const fetchItems = () => {
    axios.get(`${BudgetApi}?project=` + projectId).then((res) => {
      const items = res.data?.map((item) => {
        const children = item?.sub_items?.map((sub_item) => {
          return {
            ...sub_item,
            boq_item: sub_item.boq_sub_item,
            category_name: sub_item?.category_name_id,
          };
        });
        if (children?.length > 0) {
          return {
            ...item,
            children: children,
          };
        }
        return { ...item };
      });
      setItems(items);
    });
  };
  const onChange = (value, data, name) => {
    const arr = selectedItems;
    if (data?.boq_item) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].boq_item && arr[i].id === data.id) {
          arr[i][name] = value;
        }
      }
    } else {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].boq_sub_item && arr[i].id === data.id) {
          arr[i][name] = value;
        }
      }
    }
    console.log(arr, selectedItems, "   ");
    setSelectedItems([...arr]);
    props.setItems([...arr]);
  };
  const columns = [
    {
      title: "S.no",
      key: "s_no",
      dataIndex: "s_no",
      width: 100,
    },
    {
      title: "BOQ Item",
      key: "boq_item",
      render: (data) => (
        <span>{data?.boq_item ? data?.boq_item : data?.boq_sub_item}</span>
      ),
      width: 600,
      fixed: "left",
    },
    {
      title: "Description",
      key: "item_description",
      ellipsis: {
        showTitle: false,
      },
      render: (data) => (
        <Popover
          placement="topLeft"
          title={"Item Description"}
          content={data?.item_description}
        >
          {data?.item_description}
        </Popover>
      ),
      width: 200,
    },
    {
      title: "Quantity",
      key: "quantity",
      dataIndex: "quantity",
    },
    {
      title: "Unit",
      key: "unit",
      dataIndex: "unit",
    },
    {
      title: "Make/Brand",
      key: "brand",
      dataIndex: "brand",
    },
  ];
  const columnsModal = [
    {
      title: "S.no",
      key: "s_no",
      dataIndex: "s_no",
      width: 100,
    },
    {
      title: "BOQ Item",
      key: "boq_item",
      render: (data) => (
        <span>{data?.boq_item ? data?.boq_item : data?.boq_sub_item}</span>
      ),
      width: 550,
      fixed: "left",
    },
    {
      title: "Description",
      key: "item_description",
      ellipsis: {
        showTitle: false,
      },
      render: (data) => (
        <Popover
          placement="topLeft"
          title={"Item Description"}
          content={data?.item_description}
        >
          {data?.item_description}
        </Popover>
      ),
      width: 200,
    },
    {
      title: "Quantity",
      key: "quantity",
      dataIndex: "quantity",
    },
    {
      title: "Unit",
      key: "unit",
      dataIndex: "unit",
    },
    {
      title: "Make/Brand",
      key: "brand",
      dataIndex: "brand",
    },
    {
      title: "Price",
      key: "boq_price",
      dataIndex: "boq_price",
    },
    {
      title: "Discount",
      key: "discount",
      dataIndex: "discount",
    },
    {
      title: "Tax",
      key: "tax_value",
      dataIndex: "tax_value",
    },
    {
      title: "Tax Type",
      key: "tax_type",
      render: (data) => (
        <>
          {data?.tax_type == "igst" && "IGST"}
          {data?.tax_type == "cgst_sgst" && "CGST & SGST"}
          {data?.tax_type == "none" && "None"}
        </>
      ),
    },
  ];
  const onSelectChangeSub = (selectedRowKeys, selectedRows) => {
    console.log(selectedRowsSub, "selectedRowKeys");
    var keys = selectedSubsKeys?.map((each) => each.id);
    for (var i = 0; i < selectedRowKeys?.length; i++) {}
    setSelectedRowKeysSub(...selectedRowKeysSub, selectedRowKeys);
    setSelectedRowsSub([...selectedRowsSub, selectedRows]);
  };

  const rowSelectionSub = {
    selectedRowKeysSub,
    onChange: onSelectChangeSub,
  };

  const onSelectChange = (selectedRowKeys, selectedRows) => {
    setSelectedRowKeys(selectedRowKeys);
    setSelectedRows(selectedRows);
  };

  const handleSelectedSubs = (item, subItemsSelected) => {
    const itemKey = "item_" + item;
    var data = selectedSubs;
    if (data[itemKey]) {
      data[itemKey] = subItemsSelected;
    } else {
      data[itemKey] = subItemsSelected;
    }
    setSelectedSubs(data);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const changeSelections = () => {
    let selectedRowsArr = [];
    for (let i = 0; i < selectedRows.length; i++) {
      var row = selectedRows[i];
      selectedRows[i]["discount"] = 0;
      selectedRows[i]["unit_po_price"] = selectedRows[i]["budget_price"];

      selectedRowsArr.push(row);
    }
    var selectedSubItems = selectedSubs;
    for (var key in selectedSubItems) {
      if (selectedSubItems[key].length > 0) {
        var array = selectedSubItems[key];
        for (let i = 0; i < array.length; i++) {
          var row = array[i];
          row["discount"] = 0;
          row["unit_po_price"] = row["budget_price"];
          selectedRowsArr.push(row);
        }
      }
    }
    // for (let i = 0; i < selectedRowsSub.length; i++) {
    //   var row = selectedRowsSub[i];
    //   selectedRowsSub[i]["discount"] = 0;
    //   selectedRowsArr.push(row);
    // }
    setSelectedItems([...selectedRowsArr]);
    console.log(selectedRowsArr, "selected");
    props.setItems([...selectedRowsArr]);
    setVisible(false);
  };
  console.log(selectedRowKeys, "ss");
  const onChangeDefaultTax = (val) => {
    setDefaultTax(val);
    props.setDefaultTax(val);
    var arr = selectedItems;
    for (var i = 0; i < arr.length; i++) {
      arr[i]["tax"] = val;
    }
    setSelectedItems([...arr]);
    props.setItems([...arr]);
  };
  useEffect(() => {
    console.log("ssssss");
  }, [selectedItems]);
  console.log(selectedItems, "selected");
  return (
    <React.Fragment>
      <div className="my-2">
        <Table
          dataSource={selectedItems}
          columns={columns}
          pagination={false}
          scroll={{ x: "100%" }}
          rowKey={(data) => data.id}
        />
      </div>
      <div className="my-2">
        <Button
          type="dashed"
          onClick={() => setVisible(true)}
          className="w-100"
        >
          Add/Remove Item
        </Button>
      </div>
      <Modal
        title="Add/Remove Items"
        centered
        visible={visible}
        onOk={() => changeSelections()}
        onCancel={() => setVisible(false)}
        width="90vw"
        bodyStyle={{ height: "80vh", display: "flex", padding: 8 }}
      >
        <Table
          dataSource={items}
          columns={columnsModal}
          pagination={false}
          scroll={{
            x: "100%",
            y: window.innerHeight < 720 ? "500px" : "600px",
          }}
          rowKey={(data) => data.id}
          rowSelection={rowSelection}
          // expandable={{
          //   expandedRowRender: (data) => (
          //     <SubItemTable
          //       dataSource={data?.sub_items}
          //       itemId={data?.id}
          //       setSelectedSub={handleSelectedSubs}
          //       defaultSelected={selectedRowKeysSub}
          //       defaultSelectedSubs={selectedRowsSub}
          //     />
          //   ),
          //   rowExpandable: (data) => data?.sub_items.length > 0,
          // }}
        />
      </Modal>
    </React.Fragment>
  );
};

export default ItemTable;
